// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton___zSJJ","unreadBadge":"styles_unreadBadge__2Nnio","modalContent":"styles_modalContent__3zz-g","modal":"styles_modal__2RH1x"};